
    import {defineComponent, reactive, toRefs, onMounted, watch, nextTick} from 'vue';
    import Swiper from 'swiper';
    import 'swiper/dist/css/swiper.css';

    interface ImgItem {
        smallPhotoUrl: string;
        photoPath: string;
        photoIdStr: string;
    }

    interface State {
        imgList: ImgItem[];
        bannerSwiper: object;
        slideIndex: number;
        photoName: string;
        imgLabel: string;
    }

    export default defineComponent({
        name: "swiperComponent",
        props: {
            imgList: {
                type: Array,
                default: () => {
                    return [];
                },
            },
            initialSlide: {
                type: Number,
                default: 0,
            }
        },
        setup(props: any, ctx: any) {
            let state: State = reactive({
                imgList: [],
                bannerSwiper: {},
                slideIndex: 0,
                photoName: '',
                imgLabel: '',
            })
            // const {initialSlide} = toRefs(props);
            onMounted(() => {
                nextTick(()=>{
                    // 初始化swiper
                    const {imgList, initialSlide} = toRefs(props);
                    state.imgList = imgList.value;
                    state.slideIndex = initialSlide.value;
                    state.photoName = (state.imgList[state.slideIndex] as any).remark || (state.imgList[state.slideIndex] as any).photoName;
                    state.imgLabel = (state.imgList[state.slideIndex] as any).label;
                    state.bannerSwiper = new Swiper('.swiper-container', {
                        initialSlide: initialSlide.value || 0,
                        direction: 'horizontal',
                        loop: true,
                        zoom: true,
                        virtualTranslate: false,
                        preloadImages: false,
                        observer: true,// 修改swiper自己或子元素时，自动初始化swiper
                        observeParents: true,// 修改swiper的父元素时，自动初始化swiper
                        on: {
                            slideChange: function () {
                                state.slideIndex = this.activeIndex
                                state.photoName = (state.imgList[this.activeIndex] as any).remark || (state.imgList[state.slideIndex] as any).photoName;
                                state.imgLabel = (state.imgList[this.activeIndex] as any).label;
                                // 抛出切换事件
                                let item = {
                                    index: this.activeIndex,
                                    item: state.imgList[this.activeIndex - 1]
                                }
                                ctx.emit('slideChange', item)
                            },
                            click: function (){
                                ctx.emit('clickClose')
                            },
                        }
                    })
                    watch(initialSlide, (data: any) => {
                        (state.bannerSwiper as any).slideTo(data,300,false)
                    })
                })
            })
            return {
                state
            }
        }
    })
